import moment from "moment";
import { ApiClient } from "@topline/services/apiService";
import { LocalStorageService } from "@topline/services/localStorageService";
import { AgGridService } from "@topline/services/agGridService";
import { IdSvrAuthService } from "../../../../auth/idSrvAuthService";
import { GridStateService } from "../common/gridState/gridStateService";
import { UserManagerExtension } from "@topline/services/userManagerExtension";
import { ForecastHistoryComponent } from "../../processComponents/forecastHistory.component";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastGridService } from "../../services/forecastGridService";
import { ForecastService } from "../../services/forecastService";

(function (module) {
    "use strict";

    module.component("createdForecastList", {
        template: require("./createdForecastListComponent.html"),
        bindings: {
            forecastFilter: "<",
            versions: "<"
        },
        controller: [
            "$scope",
            ForecastService.componentName,
            ForecastGridService.componentName,
            GridStateService.componentName,
            "modalService",
            IdSvrAuthService.componentName,
            "forecastProcessService",
            "forecastApprovalService",
            angularServicesNames.$uibModal,
            AgGridService.componentName,
            angularServicesNames.$translate,
            "AlertService",
            "forecastReportService",
            UserManagerExtension.componentName,
            LocalStorageService.componentName,
            ApiClient.componentName,
            "$state",
            "$stateParams",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                forecastService: ForecastService,
                forecastGridService: ForecastGridService,
                gridStateService: GridStateService,
                modalService: $TSFixMe,
                authService: IdSvrAuthService,
                forecastProcessService: $TSFixMe,
                forecastApprovalService: $TSFixMe,
                $uibModal: ng.ui.bootstrap.IModalService,
                agGridService: AgGridService,
                $translate: ng.translate.ITranslateService,
                AlertService: AlertService,
                forecastReportService: $TSFixMe,
                UserManagerExtension: UserManagerExtension,
                localStorageService: LocalStorageService,
                apiClient: ApiClient,
                $state: ng.ui.IStateService,
                $stateParams: ng.ui.IStateParamsService
            ) {
                var $ctrl = this;

                const sortModelLocalStorageKey = "createdForecastListSortModel";

                authService
                    .hasPermissionAsync("MasterPAndLImportToML")
                    .then(result => ($ctrl.canImportMasterPAndL = result));
                authService
                    .hasPermissionAsync("ChangeOracleIndex")
                    .then(result => ($ctrl.canChangeProductCodes = result));
                authService
                    .hasPermissionAsync("ChangeForecastPM")
                    .then(result => ($ctrl.canChangeProductManager = result));
                authService.hasPermissionAsync("LockForecastsEdit").then(result => ($ctrl.canLockCorrection = result));
                authService
                    .hasPermissionAsync("ApproveAnyForecast")
                    .then(result => ($ctrl.canApproveAnyForecast = result));
                authService
                    .hasPermissionAsync("ReturnToCorrectionAnyForecast")
                    .then(result => ($ctrl.canReturnToCorrectionAnyForecast = result));
                authService
                    .hasPermissionAsync("ExportMarketValueFromForecasts")
                    .then(result => ($ctrl.canDownloadMarketsReport = result));
                authService
                    .hasPermissionAsync("CorrectionAfterDefence")
                    .then(result => ($ctrl.CanCorrectAfterDefence = result));
                authService.hasPermissionAsync("DelistProduct").then(result => ($ctrl.CanDelistProduct = result));
                authService
                    .hasPermissionAsync("MasterPAndLExport")
                    .then(result => ($ctrl.CanMasterPAndLExport = result));

                $ctrl.importReportToML = forecastReportService.importReportToML;

                $ctrl.downloadChangeProductCodesFileTemplate =
                    forecastReportService.downloadChangeProductCodesFileTemplate;

                UserManagerExtension.getUserAndSubstitutionMsnuIds().then(users => ($ctrl.currenUsers = users));
                $ctrl.createNewForecast = function () {
                    $ctrl.promiseHandler = forecastService.create().then(function (forecastId: $TSFixMe) {
                        $state.go("forecast.edit", {
                            id: forecastId
                        });
                    });
                };

                $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.productCodeFilterSelected = () => {
                    $ctrl.gridApi.onFilterChanged();
                    saveGridFilterState();
                };

                $ctrl.productCodeFilterChanged = () => {
                    $ctrl.gridApi.onFilterChanged();
                    saveGridFilterState();
                };

                $ctrl.$onInit = () => {
                    $ctrl.availableVersions = $ctrl.versions;

                    if (angular.isUndefinedOrNull($ctrl.forecastFilter)) {
                        $ctrl.forecastFilter = {
                            productCode: ""
                        };
                    }

                    if ($stateParams.budgetYear) {
                        $ctrl.forecastFilter.budgetYear = $stateParams.budgetYear;
                    } else {
                        $ctrl.forecastFilter.budgetYear = moment().year() + 1;
                    }

                    if ($stateParams.budgetVersionUId) {
                        $ctrl.selectedBudgetVersion = _.chain($ctrl.availableVersions)
                            .filter((v: $TSFixMe) => v.versionId == $stateParams.budgetVersionUId)
                            .first()
                            .value();
                    } else {
                        $ctrl.selectedBudgetVersion = _.chain($ctrl.availableVersions)
                            .find((v: $TSFixMe) => v.isMainVersion)
                            .value();
                    }

                    $ctrl.forecastFilter.budgetVersionUId = ($ctrl.selectedBudgetVersion || {}).versionId;
                };

                $ctrl.getForecastProductCodes = (searchString: $TSFixMe) => {
                    return forecastGridService.searchProductCodes(searchString);
                };

                $ctrl.budgetYearChanged = () => {
                    if (!$ctrl.forecastFilter.budgetYear) {
                        $ctrl.selectedBudgetVersion = undefined;
                        $ctrl.forecastFilter.budgetVersionUId = undefined;
                        $ctrl.gridApi.onFilterChanged();
                        return;
                    }

                    apiClient.getBudgetVersionsForYear($ctrl.forecastFilter.budgetYear).then(versions => {
                        $ctrl.availableVersions = versions;

                        $ctrl.selectedBudgetVersion = _.chain($ctrl.availableVersions)
                            .find((v: $TSFixMe) => v.isMainVersion)
                            .value();
                        $ctrl.forecastFilter.budgetVersionUId = ($ctrl.selectedBudgetVersion || {}).versionId;

                        $ctrl.gridApi.onFilterChanged();
                    });
                };

                $ctrl.budgetVersionChanged = () => {
                    $ctrl.forecastFilter.budgetVersionUId = ($ctrl.selectedBudgetVersion || {}).versionId;

                    $ctrl.gridApi.onFilterChanged();
                };

                $ctrl.forecastAgGridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.NAME"),
                            field: "name",
                            filter: "agTextColumnFilter",
                            filterParams: {
                                newRowsAction: "keep"
                            },
                            cellRenderer: (params: $TSFixMe) =>
                                params.data
                                    ? `<div class="ui-grid-cell-contents">
                            <span>                             
                                <i ng-show="!data.isEditable" class="fas fa-lock"></i>
                            </span>
                            <a href="/forecast/edit/${params.data.id}" >${params.data.name}</a>
                            </div>`
                                    : null
                        },
                        {
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.MODIFICATION_TIME"),
                            field: "modificationTime",
                            filter: "agTextColumnFilter",
                            suppressMenu: true,
                            sort: "desc"
                        },
                        {
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.CREATED_BY"),
                            field: "productManager",
                            filter: "agTextColumnFilter",
                            template:
                                '<a href="#" ng-show="$ctrl.canChangeProductManager" ng-click="$ctrl.changeProductManager(data)"> <i class="glyphicon glyphicon-user"></i></a> {{data.productManager}}'
                        },
                        {
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.MARKET"),
                            field: "marketName",
                            filter: "agTextColumnFilter",
                            cellRenderer: (params: $TSFixMe) => renderMarketCell(params)
                        },
                        {
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.COUNTRY"),
                            field: "marketCountry",
                            filter: "agTextColumnFilter"
                        },
                        {
                            field: "marketType",
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.MARTKET_TYPE"),
                            filter: "agSetColumnFilter",
                            valueFormatter: (params: $TSFixMe) =>
                                params.value ? $translate.instant(`DATA_SOURCES.${params.value}`) : "",
                            filterParams: {
                                values: ["Ims", "File", "ScoringCards", "ScoringCardsPoland"],
                                newRowsAction: "keep",
                                valueFormatter: (params: $TSFixMe) =>
                                    params.value ? $translate.instant(`DATA_SOURCES.${params.value}`) : ""
                            },
                            floatingFilterComponentParams: {
                                suppressFilterButton: false
                            }
                        },
                        {
                            field: "status",
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.STATUS"),
                            filter: "agSetColumnFilter",
                            valueFormatter: (params: $TSFixMe) =>
                                params.value ? $translate.instant(params.value) : "",
                            filterParams: {
                                values: ["AwaitingBUMApproval", "ReturnedToCorrection", "Approved"],
                                newRowsAction: "keep",
                                valueFormatter: (params: $TSFixMe) =>
                                    params.value ? $translate.instant(params.value) : ""
                            },
                            floatingFilterComponentParams: {
                                suppressFilterButton: false
                            }
                        },
                        {
                            field: "assignedPerson",
                            headerValueGetter: () => $translate.instant("FORECAST_LIST.GRID.ASSIGNED_PERSON"),
                            filter: "agTextColumnFilter"
                        },
                        {
                            headerValueGetter: () => $translate.instant("ACTIONS"),
                            template: `<div class="ui-grid-cell-contents">
                            <a href="#" ng-show="$ctrl.canApprove(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.ACCEPT' | translate }}" ng-click="$ctrl.approve(data)"><i class="glyphicon glyphicon-ok"></i></a>
                            <a href="#" ng-show="$ctrl.canSendToApproval(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.SEND_FORECAST_TO_ACCEPTANCE' | translate }}" ng-click="$ctrl.sendToApproval(data)"><i class="glyphicon glyphicon-ok"></i></a>
                            <a href="#" ng-show="$ctrl.canReject(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.RETURN_TO_CORRECTION' | translate }}" ng-click="$ctrl.reject(data)"><i class="glyphicon glyphicon-remove"></i></a>
                            <a href="#" ng-show="$ctrl.canCorrectDefended(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.SEND_FORECAST_TO_ACCEPTANCE_AFTER_DEFENCE' | translate }}" ng-click="$ctrl.correctDefended(data)"><i class="glyphicon glyphicon-pencil"></i></a>
                            <a href="#" ng-click="$ctrl.showHistory(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.HISTORY' | translate }}"> <i class="glyphicon glyphicon-list"></i></a>
                            <a href="#" ng-show="$ctrl.canDownloadReport(data)" ng-click="$ctrl.downloadReport(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.PLREPORT' | translate }}"><i class="glyphicon glyphicon-download-alt"></i></a>
                            <a href="#" ng-show="$ctrl.canRemoveCorrectionAfterDefence(data)" ng-click="$ctrl.removeCorrectionAfterDefence(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.REMOVE_CORRECTION_AFTER_DEFENCE' | translate }}"><i class="glyphicon glyphicon-step-backward"></i></a>
                            <a href="#" ng-show="$ctrl.canEnlist(data)" ng-click="$ctrl.enlistForecast(data)" data-toggle="tooltip" data-placement="top" title="{{ 'FORECAST_LIST.ENLIST' | translate }}"><i class="fas fa-sort-amount-up"></i></a>
                            <a href="#" ng-show="$ctrl.canDelist(data)" ng-click="$ctrl.delistForecast(data)" data-toggle="tooltip" data-placement="top" title="{{ 'FORECAST_LIST.DELIST' | translate }}"><i class="fas fa-sort-amount-down"></i></a>
                            </div>`,
                            filter: false,
                            sortable: false,
                            suppressMenu: true
                        }
                    ],
                    floatingFilter: true,
                    angularCompileRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true,
                        filterParams: {
                            newRowsAction: "keep"
                        },
                        floatingFilterComponentParams: {
                            suppressFilterButton: true
                        }
                    },
                    animateRows: true,
                    pagination: true,
                    domLayout: "autoHeight",
                    rowModelType: "serverSide",
                    rowGroupPanelShow: "never",
                    suppressMultiSort: true,
                    localeTextFunc: agGridService.transalteFunc,
                    popupParent: document.getElementById("createdForecastGrid"),
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.setServerSideDatasource(
                            forecastGridService.createCreatedForecastDataSource($ctrl.forecastFilter)
                        );
                        const sortModel = localStorageService.getItem(sortModelLocalStorageKey);
                        if (sortModel) {
                            $ctrl.gridApi.setSortModel(sortModel);
                        }
                        if ($ctrl.forecastFilter.agGridFilterModel) {
                            $ctrl.gridApi.setFilterModel($ctrl.forecastFilter.agGridFilterModel);
                        }
                    },
                    onSortChanged: (config: $TSFixMe) => {
                        const sortModel = $ctrl.gridApi.getSortModel();
                        localStorageService.setItem(sortModelLocalStorageKey, sortModel);
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    },
                    onFilterChanged: (event: $TSFixMe) => {
                        $ctrl.forecastFilter.agGridFilterModel = event.api.getFilterModel();
                        saveGridFilterState();
                    }
                };

                const errorHandler = (err: $TSFixMe) => {
                    switch (err.status) {
                        case HttpStatus.NotAcceptable:
                            AlertService.error($translate.instant("FORECAST_EDIT_LOCKED"));
                            break;
                        case HttpStatus.Conflict:
                            forecastApprovalService.showApproveValidationErrors(err.data);
                            break;
                        case HttpStatus.PreconditionFailed:
                            AlertService.error($translate.instant("NO_GM_IN_PANDL"));
                            break;
                    }
                };
                $ctrl.reloadPageSize = (value: $TSFixMe) => {
                    if ($ctrl.forecastAgGridOptions.api) {
                        $ctrl.forecastAgGridOptions.api.paginationSetPageSize(value);
                    }
                };

                $ctrl.canSendToApproval = (entity: $TSFixMe) =>
                    entity.status == "ReturnedToCorrection" &&
                    $ctrl.currenUsers.includes(entity.assignedPersonMsnuId) &&
                    entity.isEditable;

                $ctrl.sendToApproval = function (entity: $TSFixMe) {
                    $ctrl.promiseHandler = forecastApprovalService
                        .sendToApprovalInVersion(entity.id, $ctrl.selectedBudgetVersion)
                        .then(function (data: $TSFixMe) {
                            AlertService.success($translate.instant("FORECAST_LIST.SEND_TO_APPROVAL"));
                            getPage();
                        });
                };

                $ctrl.canApprove = (entity: $TSFixMe) =>
                    (entity.status == "AwaitingBUMApproval" || entity.status === "CorrectionAfterDefence") &&
                    ($ctrl.canApproveAnyForecast || $ctrl.currenUsers.includes(entity.assignedPersonMsnuId)) &&
                    entity.isEditable;

                $ctrl.approve = function (entity: $TSFixMe) {
                    var actionMap = Object.freeze({
                        AwaitingBUMApproval: function (id: $TSFixMe) {
                            return forecastApprovalService.approve(id);
                        },
                        CorrectionAfterDefence: function (id: $TSFixMe) {
                            return forecastApprovalService.approveCorrectionAfterDefence(id);
                        }
                    });

                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    $ctrl.promiseHandler = actionMap[entity.status](entity.id).then((response: $TSFixMe) => {
                        AlertService.success($translate.instant("FORECAST_LIST.APPROVED"));
                        getPage();
                    });
                };

                $ctrl.canReject = (entity: $TSFixMe) => {
                    const allowedStatuses = Object.freeze([
                        "AwaitingBUMApproval",
                        "Approved",
                        "ApprovedCorrectionAfterDefence"
                    ]);
                    return (
                        !!allowedStatuses.find(x => x === entity.status) &&
                        ($ctrl.canReturnToCorrectionAnyForecast ||
                            $ctrl.currenUsers.includes(entity.businessUnitManagerMsnuId)) &&
                        entity.isEditable
                    );
                };

                $ctrl.canCorrectDefended = (entity: $TSFixMe) =>
                    entity.status === "Approved" && $ctrl.CanCorrectAfterDefence && entity.isEditable;

                $ctrl.canRemoveCorrectionAfterDefence = (entity: $TSFixMe) => {
                    const allowedStatuses = Object.freeze(["Approved"]);
                    return (
                        entity.hasCorrectionAfterDefece &&
                        $ctrl.CanCorrectAfterDefence &&
                        !!allowedStatuses.find(x => x === entity.status) &&
                        entity.isEditable
                    );
                };

                $ctrl.removeCorrectionAfterDefence = function (entity: $TSFixMe) {
                    modalService.showConfirmationModal("FORECAST_LIST.REMOVE_CORRECTION_AFTER_DEFENCE", () => {
                        forecastProcessService.removeForecastCorrectionAfterDefence(entity.id).then(() => {
                            getPage();
                        });
                    });
                };

                $ctrl.correctDefended = function (entity: $TSFixMe) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: "forecastUpdate",
                        resolve: {
                            entity: () => entity
                        },
                        windowClass: "wider-modal-window"
                    });

                    modalInstance.result.then(
                        function (data: $TSFixMe) {
                            $ctrl.promiseHandler = forecastProcessService
                                .sendToApprovalAfterDefence(entity.id, data.jsonData, data.comment)
                                .then(function (data: $TSFixMe) {
                                    AlertService.success(
                                        $translate.instant("FORECAST_LIST.CORRECTION_AFTER_DEFENCE_DONE")
                                    );
                                    getPage();
                                })
                                .catch((err: $TSFixMe) => errorHandler(err));
                        },
                        function () {}
                    );
                };

                $ctrl.reject = function (entity: $TSFixMe) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: "forecastReject",
                        resolve: {
                            modalTitle: () => $translate.instant("FORECAST_ACCEPTANCE.CORRECTION.TITLE")
                        }
                    });

                    modalInstance.result.then(
                        function (comment: $TSFixMe) {
                            $ctrl.promiseHandler = forecastProcessService
                                .sendToCorrection(entity.id, comment)
                                .then(function (data: $TSFixMe) {
                                    AlertService.success($translate.instant("FORECAST_LIST.SEND_TO_CORRECTION"));
                                    getPage();
                                })
                                .catch((err: $TSFixMe) => errorHandler(err));
                        },
                        function () {}
                    );
                };

                $ctrl.canDownloadReport = (entity: $TSFixMe) =>
                    $ctrl.CanMasterPAndLExport &&
                    (entity.status == "Approved" || entity.status == "ApprovedCorrectionAfterDefence");

                $ctrl.downloadReport = (entity: $TSFixMe) => forecastReportService.downloadReport(entity);

                $ctrl.downloadMarketsReport = () => {
                    const filterInstance = angular.copy($ctrl.forecastFilter);
                    agGridService.addFilterToObject($ctrl.gridApi.getFilterModel(), filterInstance);
                    forecastReportService.downloadMarketReport(filterInstance);
                };

                $ctrl.canEnlist = (entity: $TSFixMe) =>
                    entity.isDelisted && entity.status == "Approved" && $ctrl.CanDelistProduct && entity.isEditable;

                $ctrl.enlistForecast = (data: $TSFixMe) => {
                    modalService.showConfirmationModal("FORECAST_LIST.ENLIST_CONFIRMATION", () => {
                        forecastProcessService.enlist(data.id).then(() => getPage());
                    });
                };

                $ctrl.delistForecast = (data: $TSFixMe) => {
                    modalService.showConfirmationModal("FORECAST_LIST.DELIST_CONFIRMATION", () => {
                        forecastProcessService.delist(data.id).then(() => getPage());
                    });
                };

                $ctrl.canDelist = (entity: $TSFixMe) =>
                    !entity.isDelisted && entity.status == "Approved" && $ctrl.CanDelistProduct && entity.isEditable;

                $ctrl.showHistory = (forecast: $TSFixMe) => {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: ForecastHistoryComponent.componentName,
                        size: "lg",
                        resolve: {
                            forecastId: () => forecast.id,
                            name: () => forecast.name
                        }
                    });
                    modalInstance.result.then(
                        () => {},
                        () => {}
                    );
                };

                $ctrl.changeProductManager = (data: $TSFixMe) => {
                    const modalInstance = $uibModal.open({
                        component: "changeProductManager",
                        resolve: {
                            productManagerMsnuId: () => data.productManagerMsnuId,
                            name: () => data.name
                        }
                    });
                    modalInstance.result.then(
                        (productManager: $TSFixMe) => {
                            $scope.serverOperation = forecastProcessService
                                .changeProductManager(data.id, productManager.msnuId)
                                .then(() => getPage());
                        },
                        () => {}
                    );
                };

                $ctrl.changeProductCodes = (file: $TSFixMe) => {
                    forecastReportService.changeProductCodes(file).then((changes: $TSFixMe) => {
                        const modalInstance = $uibModal.open({
                            component: "forecastChangeProductCode",
                            windowClass: "very-wide-modal-window",
                            resolve: {
                                changes: () => changes
                            }
                        });

                        modalInstance.result.then(() => getPage());
                    });
                };

                var getPage = function () {
                    $ctrl.gridApi.onFilterChanged();
                };

                var renderMarketCell = function (params: $TSFixMe) {
                    return params.data
                        ? params.data.hasForecastMarketDump
                            ? `<div class="ui-grid-cell-contents"><a href="forecast/market-dump/${params.data.id}" >${
                                  params.data.marketVersion != "" && params.data.marketVersion != null
                                      ? params.data.marketName + "-" + params.data.marketVersion
                                      : params.data.marketName
                              } - ${params.data.creationTime}</a></div>`
                            : `<div class="ui-grid-cell-contents"><a href="market/${params.data.marketType.toLowerCase()}/edit/${
                                  params.data.marketId
                              }" >${
                                  params.data.marketVersion != "" && params.data.marketVersion != null
                                      ? params.data.marketName + "-" + params.data.marketVersion
                                      : params.data.marketName
                              }</a></div>`
                        : null;
                };

                function saveGridFilterState() {
                    gridStateService.setItem("createdForecastListFilterState", $ctrl.forecastFilter);
                }
            }
        ]
    });
})(angular.module("topline.modules"));
